'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagInAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.76243e-05 -1.52588e-05H28C28 6.66665 28 13.3333 28 20C18.6667 20 9.33333 20 -1.52588e-05 20C-5.11082e-06 13.3333 -2.32024e-05 6.66665 1.76243e-05 -1.52588e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.21407e-05 6.66665H28V-1.52588e-05H1.76243e-05L1.21407e-05 6.66665Z",
          fill: "#FFA44A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-1.52588e-05 20H28V13.3333H1.21407e-05L-1.52588e-05 20Z",
          fill: "#1A9F0B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 12C15.1046 12 16 11.1046 16 9.99998C16 8.89541 15.1046 7.99998 14 7.99998C12.8954 7.99998 12 8.89541 12 9.99998C12 11.1046 12.8954 12 14 12Z",
          fill: "#181A93",
          fillOpacity: 0.15
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.6667 9.99998C16.6667 11.4727 15.4728 12.6666 14 12.6666C12.5273 12.6666 11.3333 11.4727 11.3333 9.99998C11.3333 8.52722 12.5273 7.33332 14 7.33332C15.4728 7.33332 16.6667 8.52722 16.6667 9.99998ZM16 9.99998C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 9.99998C12 8.89541 12.8954 7.99998 14 7.99998C15.1046 7.99998 16 8.89541 16 9.99998Z",
          fill: "#181A93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 10.6666C14.3682 10.6666 14.6667 10.3682 14.6667 9.99998C14.6667 9.63179 14.3682 9.33332 14 9.33332C13.6318 9.33332 13.3333 9.63179 13.3333 9.99998C13.3333 10.3682 13.6318 10.6666 14 10.6666Z",
          fill: "#181A93"
        }
      )
    ]
  }
);
const VpFlagInAsset = forwardRef(FlagInAsset);

export { VpFlagInAsset as default };
